// Los documentos de ONBOARDING del cliente. Es otra lectura, con otro permiso
// (`retail.customer.documents.read`): su 403 no puede vaciar los contratos del crédito de al lado.
import { useQuery } from '@tanstack/react-query';
import {
    getCustomerDocuments,
    type CustomerDocumentsResponse,
} from '@/api/services/retail-customer/retail-customer.client';
import { readFailureOf, type ReadFailure } from '../lib/creditCustomersErrors';

const KEY = ['credit-admin', 'customer-documents'] as const;

const STALE_TIME_MS = 60_000;

export interface CustomerDocumentsState {
    data: CustomerDocumentsResponse | undefined;
    isLoading: boolean;
    failure: ReadFailure | null;
    retry: () => void;
}

/** `GET /customers/{id}/documents` — solo el onboarding; los contratos son otro endpoint. */
export function useCustomerDocuments(retailCustomerId: string | null): CustomerDocumentsState {
    const query = useQuery({
        queryKey: [...KEY, retailCustomerId],
        queryFn: () => getCustomerDocuments(retailCustomerId ?? ''),
        enabled: retailCustomerId !== null,
        staleTime: STALE_TIME_MS,
        retry: false,
    });

    return {
        data: query.data,
        isLoading: retailCustomerId !== null && query.isPending,
        failure: readFailureOf(query.error),
        retry: () => {
            void query.refetch();
        },
    };
}
